import { render, staticRenderFns } from "./IndexPageRolloverLabel.vue?vue&type=template&id=5dac1500&scoped=true&"
import script from "./IndexPageRolloverLabel.vue?vue&type=script&lang=ts&"
export * from "./IndexPageRolloverLabel.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPageRolloverLabel.vue?vue&type=style&index=0&id=5dac1500&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dac1500",
  null
  
)

export default component.exports